import { defineStore } from 'pinia'

interface SliderState {
  sliderStates: { [key: string]: boolean };
}

/**
 * Store for managing slider states across the application
 * Each slider is identified by a unique id
 */
export const useSliderStore = defineStore('slider', {
  state: (): SliderState => ({
    // Map to store open/closed state for different SliderTabsBar instances
    sliderStates: {}
  }),
  
  actions: {
    /**
     * Set slider state for a specific slider by id
     * @param sliderId - Unique identifier for the slider
     * @param isOpen - Whether the slider is open (tabs shown) or closed (search shown)
     */
    setSliderState(sliderId: string, isOpen: boolean) {
      this.sliderStates[sliderId] = isOpen
    },
    
    /**
     * Get slider state for a specific slider by id
     * @param sliderId - Unique identifier for the slider
     * @param defaultState - Default state to return if slider state is not found
     * @returns - Current state of the slider (true = tabs open, false = search open)
     */
    getSliderState(sliderId: string, defaultState: boolean = true): boolean {
      return this.sliderStates[sliderId] !== undefined 
        ? this.sliderStates[sliderId] 
        : defaultState
    }
  }
}) 